import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { menuOffersAccessGuard } from './guards/menu-offers-access.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'notifications',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'auth/set-password',
    loadComponent: () =>
      import('./auth/set-password/set-password.page').then((m) => m.SetPasswordPage),
  },
  {
    path: 'menu',
    loadComponent: () => import('./menu/menu.page').then((m) => m.MenuPage),
    canActivate: [authGuard],
  },
  {
    path: 'menu-offers',
    loadComponent: () => import('./menu-offers/menu-offers.page').then((m) => m.MenuOffersPage),
    canActivate: [authGuard, menuOffersAccessGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'deals' },
      {
        path: 'deals',
        loadComponent: () =>
          import('./menu-offers/menu-deals/menu-deals.page').then((m) => m.MenuDealsPage),
      },
      {
        path: 'upgrades',
        loadComponent: () =>
          import('./menu-offers/menu-upgrades/menu-upgrades.page').then((m) => m.MenuUpgradesPage),
      },
    ],
  },
  {
    path: 'extras',
    loadComponent: () => import('./modifiers/modifiers.page').then((m) => m.ModifierPage),
    canActivate: [authGuard],
  },
  {
    path: 'orders',
    loadComponent: () => import('./orders/order.page').then((m) => m.OrderPage),
    canActivate: [authGuard],
  },
  {
    path: 'takeaway-orders',
    loadComponent: () =>
      import('./takeaway-orders/takeaway-order.page').then((m) => m.TakeawayOrderPage),
    canActivate: [authGuard],
  },
  {
    path: 'allergens',
    loadComponent: () => import('./allergens/allergens.page').then((m) => m.AllergensPage),
    canActivate: [authGuard],
  },
  {
    path: 'categories',
    loadComponent: () => import('./categories/categories.page').then((m) => m.CategoriesPage),
    canActivate: [authGuard],
  },
  {
    path: 'notifications',
    loadComponent: () => import('./notification/notification.page').then((m) => m.NotificationPage),
    canActivate: [authGuard],
  },
  {
    path: 'outlet',
    loadComponent: () => import('./outlet/outlet.page').then((m) => m.OutletPage),
    canActivate: [authGuard],
  },
  {
    path: 'recommendations',
    loadComponent: () =>
      import('./recommendations/recommendations.page').then((m) => m.RecommendationsPage),
    canActivate: [authGuard],
  },
  {
    path: 'analytics',
    loadComponent: () => import('./analytics/analytics.page').then((m) => m.AnalyticsPage),
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    loadComponent: () => import('./settings/settings.page').then((m) => m.SettingsPage),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: 'notifications',
    pathMatch: 'full',
  },
];
